import React from 'react';
import PropTypes from 'prop-types';
import { Icon, InputText } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { FORM_KEYS } from '../../../../../constants/formKeys';
import { VALIDATION_ERROR_MESSAGE } from '../../../../../constants/errorMessage';
import ErrorText from '../../../../shared/ErrorText/ErrorText';

const ConfirmNewPasswordField = ({
  fieldFormContext,
  showPassword,
  confirmPasswordOnChange,
  errors,
  togglePasswordVisibility
}) => {
  return (
    <div className="passwordFieldContainer">
      <div className="newPasswordInputContainer">
        <InputText
          {...{
            fieldFormContext,
            label: 'Confirm password',
            name: FORM_KEYS.CONFIRM_PASSWORD,
            inputType: showPassword.confirm ? 'text' : 'password',
            placeholder: 'Confirm your new password',
            defaultValue: '',
            validation: {
              required: 'Please confirm your password.'
            },
            customChangeHandler: confirmPasswordOnChange,
            customCssClass: errors.isInvalidConfirmPassword ? 'confirmPasswordField error' : 'confirmPasswordField',
            customPostInputContent: (
              <Icon
                icon={showPassword.confirm ? 'password-visible' : 'password-hidden'}
                onClick={() => togglePasswordVisibility('confirm')}
                customCssClass="toggle-password-icon"
              />
            )
          }}
        />
      </div>
      <div className="custom_validation_list">
        <ErrorText
          cssClass="custom_validation"
          message={[
            { value: VALIDATION_ERROR_MESSAGE.INVALID_CONFIRM_PASSWORD, isDisplayed: errors.isInvalidConfirmPassword }
          ]}
        />
      </div>
    </div>
  );
};

export default ConfirmNewPasswordField;

ConfirmNewPasswordField.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: PropTypes.any.isRequired,
  showPassword: PropTypes.shape({
    confirm: PropTypes.bool.isRequired
  }).isRequired,
  confirmPasswordOnChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    isInvalidConfirmPassword: PropTypes.bool.isRequired
  }).isRequired,
  togglePasswordVisibility: PropTypes.func.isRequired
};
